import Typography, { TypographyProps } from '@mui/material/Typography'
import styled from '@mui/material/styles/styled'

interface StyledTypographyCustomProps extends TypographyProps {
  fontColor?: string
  fontSize?: number
  fontWeight?: string
  isUnderlined?: boolean
  isUppercased?: boolean
  lineHeight?: string
  margin?: string
  marginBottom?: number
}

export const StyledTypography = styled(Typography, {
  name: 'DirectBilling',
  slot: 'StyledTypography',
  shouldForwardProp: prop =>
    prop !== 'fontColor' && prop !== 'isUnderlined' && prop !== 'marginBottom' && prop !== 'isUppercased',
})<StyledTypographyCustomProps>(
  ({ fontSize, fontColor, fontWeight, isUnderlined, isUppercased, lineHeight, margin, marginBottom, theme }) => ({
    margin: margin,
    marginBottom: marginBottom === undefined ? theme.spacing(4) : theme.spacing(marginBottom),
    textDecoration: isUnderlined ? 'underline' : undefined,
    textTransform: isUppercased ? 'uppercase' : 'none',
    color: fontColor ? fontColor : undefined,
    fontSize: fontSize ? fontSize : undefined,
    fontWeight: fontWeight ? fontWeight : undefined,
    lineHeight: lineHeight ? lineHeight : undefined,
    fontFamily: 'inherit',
  })
)
